// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"65343867","309":"46733899","676":"331c70a8","876":"170585a2"}[chunkId] + ".chunk.js";
};